// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#resident-status-tab-component .cancel-btn[data-v-f179835a],#resident-status-tab-component .update-btn[data-v-f179835a]{width:120px}#resident-status-tab-component .box-footer[data-v-f179835a]{padding:10px 0 0 0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
